const AxesOptions = [
{"nombre": "Legislación", "slug": "legislacion"},
{"nombre": "Igualdad", "slug": "igualdad"},
{"nombre": "Corresponsabilidad", "slug": "corresponsabilidad"},
{"nombre": "Estadísticas", "slug": "estadisticas"},
{"nombre": "Lenguaje", "slug": "lenguaje"},
{"nombre": "Sensibilización", "slug": "sensibilizacion"},
{"nombre": "Estudios de Género", "slug": "estudiosdegenero"},
{"nombre": "No violencia", "slug": "violencia"},
]

export default AxesOptions;